import React from 'react'
import PropTypes from 'prop-types'

const HomeWorkIcon = (props) => {
  const { color = '#ffffff', classes = 'w-20' } = props
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 12H20V10H18V12ZM18 16H20V14H18V16ZM18 20H20V18H18V20ZM18 24V22H22V8H13V9.4L11 7.95V6H24V24H18ZM2 24V14L9 9L16 14V24H10V19H8V24H2ZM4 22H6V17H12V22H14V15L9 11.45L4 15V22Z"
        fill={color}
      />
    </svg>
  )
}

HomeWorkIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(HomeWorkIcon)
